import { css } from "lit";

export const RichTextStyles = css`

h1, h2, h3, h4, h5, h6 {
    font-weight: var(--font-weight-light);
    line-height: 125%;
    margin: 0;
    margin-block: .8em .25em;
}

strong { font-weight: var(--font-weight-medium); }

h1 { font-size: var(--font-size-header-1); }

h2 { font-size: var(--font-size-header-2); }

h3 { font-size: var(--font-size-header-3); }

h4 { font-size: var(--font-size-header-4); }

h5 { font-size: var(--font-size-header-5); }

p {
    font-size: var(--font-size-body-lg);
    line-height: 150%;
    margin: 0;
    &:has(+ p) {
        margin-block-end: .75em;
    }
}

h1, h2, h3, h4, h5, h6, p {
    text-wrap-style: pretty;

    a {
        text-decoration: none;
        color: light-dark(var(--color-button-text-link), var(--color-button-light));
        font-weight: var(--font-weight-medium);
        &:hover {
            color: light-dark(var(--color-button-text-link-hover), var(--color-button-light-hover));
            text-decoration: underline;
        }
    }
}
`